import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutPrimaryHeliumHeroContentSectionInnerCls: string;
			aboutPremiumHeliumHeroHeaderCustomCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About Primary Helium Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPrimaryHeliumHeroContentSectionInnerCls || '',
			'about_primary_helium_hero', { animCls: 'animate__zoomIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPremiumHeliumHeroHeaderCustomCls || '',
			'about_primary_helium_hero', { animCls: 'animate__fadeInRight', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;